import InsureProcess from './InsureProcess';
export default InsureProcess;
